<template>

    <v-flex xs12 sm10 offset-sm1 md8 offset-md2 lg6 offset-lg3 mt-2 mb-2>
        <!-- Alert -->
        <Alert v-if="alertType !== ''" :atype="alertType" :message="message" :visibility="visibility" />

        <v-progress-linear v-if="progressbar" :indeterminate="true"></v-progress-linear>

        <v-card class="semi-transparent-bg" v-if="items.length > 0">

            <v-list two-line class="semi-transparent-bg">

                <template v-for="(item, index) in items">

                    <v-list-tile
                        :key="'contact' + item.id"
                        avatar
                        @click.prevent="item.contentType == 'textarea' ? toChat(item.id) : popUpDialog(item.id)">

                        <v-list-tile-avatar>

                            <img :src="item.avatar">

                        </v-list-tile-avatar>

                        <v-list-tile-content>

                            <v-list-tile-title v-html="item.name"></v-list-tile-title>

                            <v-list-tile-sub-title v-html="item.contact"></v-list-tile-sub-title>

                        </v-list-tile-content>

                        <v-list-tile-action>

                            <v-icon>chat</v-icon>

                        </v-list-tile-action>

                    </v-list-tile>

                     <v-divider v-if="index+1 !== items.length" :key="index"></v-divider>

                </template>

            </v-list>

        </v-card>

            <v-dialog v-model="popUp" persistent max-width="290" class="semi-transparent-7-bg">

                <v-card v-if="popUpDetail" class="semi-transparent-7-bg">

                    <v-img :src="popUpDetail.script"></v-img>

                    <v-card-title class="headline">{{ popUpDetail.name }}</v-card-title>

                    <v-card-actions>

                        <v-spacer></v-spacer>

                        <v-btn color="green darken-1" flat @click="popUp = false">
                            {{ $t( 'reusable.close' ) }}
                        </v-btn>

                    </v-card-actions>

                </v-card>

            </v-dialog>

    </v-flex>

</template>


<script>
import Alert from "@/components/Reusable/Alert.vue";
import Api from "@/api";

export default {
    data() {
        return {
            items: [],
            progressbar: false,
            alertType: "",
            message: "",
            visibility: "",
            popUp:false,
            popUpDetail: {}
        }
    },
    components: {
        Alert
    },
    methods: {
        resetAlert() {

            this.visibility = false;

            this.message = "";

            this.alertType = "";

            this.progressbar = false;

        },
        getImgUrl(bank) {

            var images = require.context('@/assets/contact/', false, /\.png$/);

            return images('./' + bank + ".png");

        },
        toChat(id) {
            if (this.items[id]['script']) {

                window.open(this.items[id]['script']);

            } else{

                switch(this.items[id]['type']) {

                    case 'phone':
                        window.open('tel:' + this.items[id]['contact']);
                        break;

                    case 'facebook':
                        // fb://page/<id_here>
                        window.open(this.items[id]['contact'], '_system');
                        break;

                    case 'instagram':
                        window.open('instagram://user?username=' + this.items[id]['contact']);
                        // 'instagram://user?username=<username>;
                        break;

                    case 'line':
                        window.open('line://ti/p/@' + this.items[id]['contact']);
                        // "line://ti/p/@UserlineID"
                        break;

                    case 'skype':
                        // skype:some_skype_user?chat'
                        window.open('skype:' + this.items[id]['contact'] + '?chat');
                        break;

                    case 'telegram':
                        // https://t.me/USERNAME
                        window.open('https://t.me/' + this.items[id]['contact']);
                        break;

                    case 'wechat':
                        // weixin://dl/chat?{toID}
                        window.open('weixin://dl/chat?' + this.items[id]['contact']);
                        break;

                    case 'whatsapp':
                        // whatsapp://send?text=The text to share!
                        window.open('whatsapp://send?text=Hi%2C%20I%20am%20interested&phone=' + this.items[id]['contact']);
                        break;

                    case 'twitter':
                        // twitter://user?screen_name=<page>
                        window.open('twitter://user?screen_name=' + this.items[id]['contact']);
                        break;
                     case 'zalo':

                        // http://zaloapp.com/qr/p/{UserID}
                        window.open('http://zaloapp.com/qr/p/' + this.items[id]['contact']);
                        break;

                    default:
                        break;

                }

            }

        },
        popUpDialog(id) {

            this.popUp = true;

            this.popUpDetail = this.items[id];

        }
    },
    mounted: async function() {

        this.progressbar = true;

        let res = await Api.getContact();

        if (res && 'success' in res && res.success != true) {

            this.visibility = true;

            this.message = res.message;

            this.alertType = "error";

        } else {

            for (let item in res.data) {

                this.items.push({
                    'id': item,
                    'avatar': this.getImgUrl(res.data[item]['type'].toLowerCase()),
                    'name': res.data[item]['name'],
                    'contact': res.data[item]['contact'],
                    'type': res.data[item]['type'].toLowerCase(),
                    'contentType': res.data[item]['content_type'].toLowerCase(),
                    'script': res.data[item]['value']
                });

            }
        }

        this.progressbar = false;

    }

}
</script>